import * as types from './types';
import { SharingSettingsService } from '../../services/sharing-settings.service';
import { HttpClient, createHttpGetOptions } from '../../../../services/http/http-client';
import { SET_MAIN_NAV_ACTIVE } from '../../../../store/app/types';
import { REQUEST_CANCELLED } from '../../../../services/http/error-handler';
import { HttpLib } from '../../../../services/http/http-lib';
import Router from '../../../../router';
import { setMainNavInactive } from '../../../../store/app/mutations';




export const sharingSettingsActions = {
  async [types.SharingData.FETCH.ALL]({ commit }, payload) {
 
    const sharingData = await SharingSettingsService.findSharingData();
    console.log(sharingData.data);
    commit(types.SharingData.SET.ALL, sharingData.data);
  },

  // async [types.RssData.FETCH.SINGLE]({commit},artist_id){
  //  const rssFile=await SharingSettingsService.getRssData(artist_id) 
  //  let url="https://api.rss2json.com/v1/api.json?rss_url=http://detailseu.s3.amazonaws.com/rss/"+rssFile.data.file
  //  const rssJson=await SharingSettingsService.getRssJson(url)
  // //  console.log("RSS FILE",rssJson)
  //  let rssdata={
  //    artistId:artist_id,
  //    rssItem:rssJson.data.items
  //  }
  //  commit(types.RssData.SET.SINGLE,rssdata)
  // }
};

